import React from "react";
import "./ProductDetail122.css";

function ProductDetail122() {
  return (
    <div className="tpms-top-section">

      {/* HERO SECTION */}
      <section className="tpms-hero">

        <div className="tpms-hero-left px-5">

          <h1 className="tpms-title">
            {/* Transforming <br />
            Toll <br />
            Operations with <br /> */}
            <span>AI-Powered TPMS</span>
          </h1>

          <p className="tpms-desc text-justify">
            Smart IoT-based tyre pressure monitoring system designed to
            improve toll operations, increase vehicle safety, reduce downtime
            and enhance real-time analytics for better decision making.
          </p>

          <div className="tpms-buttons">
            <button className="demo-btn">Get Live Demo</button>
            <button className="video-btn1 demo-btn">Talk to Expert</button>
          </div>

        </div>

        <div className="tpms-hero-right">

          <div className="tpms-dashboard">

            <div className="tpms-row">
              <div className="tpms-card">
                <p>Vehicle Health</p>
                <h3>98.9%</h3>
              </div>

              <div className="tpms-card">
                <p>All Sensors</p>
                <h3>All 8</h3>
              </div>
            </div>

            <div className="tpms-row">
              <div className="tpms-card">
                <p>Temperature</p>
                <h3>25°</h3>
              </div>

              <div className="tpms-card">
                <p>Pressure</p>
                <h3>32 PSI</h3>
              </div>
            </div>

            <div className="tpms-progress">
              <p>System Performance</p>

              <div className="progress-bar">
                <div className="progress-fill"></div>
              </div>

              <div className="progress-bar">
                <div className="progress-fill fill2"></div>
              </div>

              <div className="progress-bar">
                <div className="progress-fill fill3"></div>
              </div>

            </div>

          </div>

        </div>

      </section>

      {/* STATS BAR */}
      <section className="tpms-stats">

        <div className="stats-box">
          <h3>97%</h3>
          <p>Accuracy</p>
        </div>

        <div className="stats-box">
          <h3>21s</h3>
          <p>Response Time</p>
        </div>

        <div className="stats-box">
          <h3>25%</h3>
          <p>Fuel Saving</p>
        </div>

        <div className="stats-box">
          <h3>120+</h3>
          <p>Fleet Monitoring</p>
        </div>

        <div className="stats-box">
          <h3>100%</h3>
          <p>Safety</p>
        </div>

      </section>

    </div>
  );
}

export default ProductDetail122;